<template>
    <modal-content :no-offset="true" @close="$emit('close')">
        <file-media-container
            :picker="true"
            :multiple-select="multipleSelect"
            :selected="selected"
            @o3-select="insertFiles"
            @close="$emit('close')"
        />
    </modal-content>
</template>

<script>
import ModalContent from '../../../../components/Modal/ModalContent';
import FileMediaContainer from './FileContainer';

export default {
    name:       'FilePickerDialog',
    components: {FileMediaContainer, ModalContent},
    props:      {
        multipleSelect: {
            type:     Boolean,
            required: false,
            default:  () => false,
        },
        selected:       {
            type:     Array,
            required: false,
            default:  () => [],
        },
        onSelect:       {
            type:     Function,
            required: false,
            default:  () => null,
        }
    },
    methods:    {
        insertFiles(data) {
            this.$emit('o3-select', data);
            if (this.onSelect) {
                this.onSelect(data);
            }
        }
    }
}
</script>


